import React from 'react'
import styled from 'styled-components'

type Props = {
  label: string
  align?: 'center' | 'left' | 'right'
}

const Header = styled.th`
  background-color: #F2F6FA;
  color: #697280;
  padding: 1.2rem .6rem;
  text-align: ${({ align }) => align || 'center'};
`

export const TableHeader: React.FC<Props> = ({
  label,
  align
}) => (
  <Header align={align}>{label}</Header>
)
